module.exports = __webpack_public_path__ + "img/fi-rr-cross-small.2ae05539.svg";